import React, { useState, useEffect } from "react";
import Button from "../../Button/Button";
import InputBox from "../../Input/Input";
import Label from "../../Label/Label";
import Modal from "../Modal";

const FavRequestModal: React.FC<{
  isVisible?: boolean;
  data?: any;
  onClick?: () => void;
  onClose: () => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ isVisible, data, onClick, onClose, handleInputChange }) => {
  const [formData, setFormData] = useState({
    favname: "",
    email: "",
  });
  const [errors, setErrors] = useState<any>({
    favname: '',
    email: '',
  });

  const [state, setState] = useState({
    isLoading: false,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        favname: data.fav_name || "",
        email: data.email || "",
      });
    }
  }, [data]);

  // Email validation function
  const validateEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const validateForm = () => {
    const newErrors: any = {};
    if (!formData.favname.trim()) {
      newErrors.favname = "Favorite Name is required.";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      setState({ isLoading: true }); 
      if (onClick) {
        await onClick(); 
        setFormData({
          favname: "",
          email: "",
        });
      }

      setState({ isLoading: false});
    }
  };

  const handleClose = () => {
    if (onClose) {
      setFormData({
        favname: "",
        email: "",
      });
      setErrors({
        favname: "",
        email: "",
      });
      onClose();
    }
  };

  const modalBody = (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (<></>
      )}
        <div className="modal-body bg-modalbody m-3 pt-0 mt-0">
          <form className="account-form text-start">
            <div className="row mb-3">
              <Label
                className="col-12 col-form-label font-inter-400-15"
                text="Favorite Name"
              />
              <div className="col">
                <InputBox
                  onChange={handleInputChange}
                  className={`form-control ${errors.favname ? 'is-invalid' : ''}`}
                  placeholder="Favorite Name"
                  name="fav_name"
                  value={formData.favname}
                />
                {errors.favname && (
                  <div className="invalid-feedback">{errors.favname}</div>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <Label
                className="col-12 col-form-label font-inter-400-15"
                text="Email"
              />
              <div className="col">
                <InputBox
                  onChange={handleInputChange}
                  className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
            </div>

            <div
              className="text-center mt-4"
              style={{
                fontFamily: "Inter",
                fontWeight: 300,
                fontSize: "13px",
                lineHeight: "20px",
                textAlign: "center",
              }}
            >
              <span className="fs-6">
                Submit your request and you’ll be notified via email when it
                becomes available
              </span>
            </div>

            <div className="mb-1 mt-4 d-flex justify-content-center">
              <Button
                label={<>Submit</>}
                variant="primary"
                className="w-100 font-18 font-500"
                onClick={handleSubmit}
              />
            </div>
          </form>
        </div>
    </>
  );

  return (
    <Modal
      id="FavRequestModal"
      title="Submit Favorite Request"
      body={modalBody}
      modalBackground={"modal-bg"}
      onClose={handleClose}
      isVisible={isVisible}
    />
  );
};

export default FavRequestModal;
